import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import type { MadeOutput } from "../../../../api/threads/workflowSwitchApi";
import { appPaths } from "../../../../shared/routing/appPaths";
import { valueText } from "../../status/valueText";
import { useThreadContext } from "../threadPageContext";
import { madeText, withProducerNames } from "./switchWords";

/**
 * What the Thread's steps made so far (F126), folded into one line until opened (P-C): each
 * output by its kind and step, under the Workflow that made it, and a link to its entry.
 */
export default function OutputsSoFar({ made }: { made: readonly MadeOutput[] }) {
  const { t } = useTranslation();
  const { threadId, workflowNameOf, stepNameIn } = useThreadContext();
  if (made.length === 0) return null;
  const byWorkflow = new Map<string, MadeOutput[]>();
  for (const output of withProducerNames(made, stepNameIn)) byWorkflow.set(output.workflow, [...(byWorkflow.get(output.workflow) ?? []), output]);
  return (
    <details>
      <summary className="app-text-muted cursor-pointer text-xs">{t("threads.switch.made", { count: made.length })}</summary>
      <div className="mt-1 space-y-1 text-xs">
        {[...byWorkflow].map(([workflow, outputs]) => (
          <div key={workflow}>
            <p className="app-text-muted">{workflowNameOf(workflow) ?? t("threads.switch.someWorkflow")}</p>
            <ul className="space-y-0.5 pl-3">
              {outputs.map((output) => (
                <li key={`${String(output.entry)}:${output.part}`}>
                  <Link className="app-link app-link-cue-up" to={appPaths.thread(threadId, output.entry)} title={valueText(output.value, t)}>{madeText(output, t)}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </details>
  );
}
